var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"r-menu"},_vm.$listeners),[_c('div',{staticClass:"r-menu--item r-menu--closebtn",on:{"click":_vm.onMenuClick}},[_vm._v("\n    ×\n  ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }